import { MetodoPago } from "./ventasServicios";
import { apiDelete, get, patch, post } from "./divertidogsApiUtils";
import { useQuery } from "@tanstack/react-query";
import { AgendamientoResumido } from "./agendamientosServicios";
import { DatosReservaTransporte } from "./reservasTransporteServicios";
import { Pagina } from "./Pagina";


export interface NuevoAgendamientoHotel {
  idMascota: string;
  descuento: number;
  datosReservaHotel: {
    fechasProgramadas: string[];
    datosTarifa?: {
      idTarifa?: string;
      precioFinal?: number;
    };
    datosNochesIndividuales?: {
      nochesIndividuales: number;
      precioFinal: number;
      idServicio: string;
    };
  };
  datosTransporte?: {
    datosTransporteIda?: DatosReservaTransporte;
    datosTransporteVuelta?: DatosReservaTransporte;
    datosTransporteIdaVuelta?: DatosReservaTransporte;
  };
  datosPago?: {
    monto: number;
    metodo: MetodoPago;
  };
}

export const agendar = async (
  nuevoAgendamientoGuarderia: NuevoAgendamientoHotel
) => {
  return post<NuevoAgendamientoHotel>(
    "agendamientos/hotel",
    nuevoAgendamientoGuarderia
  );
};

export interface AgendamientoHotelResumido extends AgendamientoResumido {
  reservaHotel: ReservaHotel;
  reservaTransporteIda?: ReservaTransporte;
  reservaTransporteVuelta?: ReservaTransporte;
  reservaTransporteIdaVuelta?: ReservaTransporte;
}

export const isAgendamientoHotelResumido = (
  agendamientoResumido: AgendamientoResumido
): agendamientoResumido is AgendamientoHotelResumido => {
  return (
    agendamientoResumido.tipoServicio === "HOTEL" &&
    "reservaHotel" in agendamientoResumido
  );
};

export interface ReservaHotel {
  tarifa?: string;
  precioFinalTarifa?: number;
  nochesIndividuales?: number;
  precioFinalNocheIndividual?: number;
  tarifaNocheIndividual?: string;
  total: number;
  fechasProgramadas: string[];
}

export interface ReservaTransporte {
  direccion: string;
  sector: string;
  tipoTrayecto: string;
  tarifa: string;
  precioFinalTarifa: number;
  total: number;
  fechasProgramadas: string[];
}

const buscarAgendamientoDeReservaHotel = async (idReservaGuarderia: string) => {
  let response = await get<AgendamientoHotelResumido>(
    `agendamientos/hotel/reservas/${idReservaGuarderia}`
  );
  return response;
};

export const QUERY_BUSCAR_AGENDAMIENTO_DE_RESERVA_HOTEL =
  "QUERY_BUSCAR_AGENDAMIENTO_DE_RESERVA_HOTEL";

export const useBuscarAgendamientoDeReservaHotel = (
  idReservaHotel: string,
  enabled: boolean
) =>
  useQuery({
    queryKey: [QUERY_BUSCAR_AGENDAMIENTO_DE_RESERVA_HOTEL, idReservaHotel],
    queryFn: async () => await buscarAgendamientoDeReservaHotel(idReservaHotel),
    enabled: enabled,
  });

export type ReagendamientoRequest = {
  idReservaHotel: string;
  fechas: Record<string, string>;
};

export const reagendarHotel = async ({
  idAgendamiento,
  request,
}: {
  idAgendamiento: string;
  request: ReagendamientoRequest;
}) => {
  return patch(`agendamientos/hotel/${idAgendamiento}/reagendar`, request);
};

export const eliminar = async (idAgendamiento: string) => {
  return apiDelete(`agendamientos/hotel/${idAgendamiento}`);
};

export type AgendamientoListado = {
  id: string;
  nombrePropietario: string;
  nombreMascota: string;
  fechaRealizacion: string;
  nombreServicio: string;
  fueCancelado: boolean;
};

export const listarTodos = async (
  queryParamsStr: string
) => {
  let response = await get<Pagina<AgendamientoListado>>(
    `agendamientos/hotel${queryParamsStr}`
  );
  return response;
};

export const QUERY_LISTAR_TODOS_AGENDAMIENTOS_HOTEL =
  "QUERY_LISTAR_TODOS_AGENDAMIENTOS_HOTEL";

export const buscarPorId = async (id: string) => {
  return get<AgendamientoHotelResumido>(`agendamientos/hotel/${id}`);
}

export const QUERY_BUSCAR_AGENDAMIENTO_HOTEL_POR_ID =
  "QUERY_BUSCAR_AGENDAMIENTO_HOTEL_POR_ID";

export const useBuscarPorId = (
  id: string
) =>
  useQuery({
    queryKey: [QUERY_BUSCAR_AGENDAMIENTO_HOTEL_POR_ID],
    queryFn: async () =>
      await buscarPorId(id)
  });